export default __webpack_public_path__ + "media/2dc532aec09176e55c694733196bdd54963e198c71830568830eaf911a4ee6d6.svg";